/**
 * Helpers functions for DOM
 */

/**
 * Scroll element to the bottom
 * @param elementId {String}
 */
function scrollToTheBottom(elementId) {
  // We need to wrap this code in a setTimeout function because it needs to be done after the DOM is re-rendered
  setTimeout(() => {
    let element = document.getElementById(elementId);
    if (element) {
      element.scrollTop = element.scrollHeight;
    }
  }, 100);
}
/**
 * Scroll element to the top
 * @param elementId {String}
 */
function scrollToTheTop(elementId) {
  // We need to wrap this code in a setTimeout function because it needs to be done after the DOM is re-rendered
  setTimeout(() => {
    let element = document.getElementById(elementId);
    if (element) {
      element.scrollTop = 0;
    }
  }, 100);
}

export { scrollToTheBottom, scrollToTheTop };
